__webpack_require__.p = "https://bmidxbspainplprod.netlify.app/";